import type { MensagemStatus } from '@/shared/types/mensagemStatus';
import type { DestinatarioMensagemCertificado } from '../types/certificadoAcessosTypes';

/**
 * Do mais fraco ao mais forte em termos do que a evidência sustenta. `FAILED` é o piso porque é o
 * único estado que nega a entrega — abaixo até de "ainda enviando".
 */
const FORCA_STATUS: Record<MensagemStatus, number> = {
  FAILED: 0,
  PENDING: 1,
  SENT: 2,
  DELIVERED: 3,
  SEEN: 4,
};

/**
 * Força de um status na mesma escala da bolha. Exposta para quem escolhe o MAIS FORTE: o status de
 * uma mensagem é o maior degrau que os avisos dela alcançaram, e um `FAILED` que chega depois de um
 * `DELIVERED` (piso da escala) não desfaz a entrega.
 */
export function forcaStatusEntrega(status: MensagemStatus): number {
  return FORCA_STATUS[status];
}

/**
 * Status que a bolha da réplica pode afirmar para um grupo de destinatários: o MAIS FRACO deles.
 *
 * A bolha é uma só para N destinatários (a réplica agrupa por conteúdo idêntico), e cada um tem
 * status próprio. Num documento probatório não existe ícone "verdadeiro" para o grupo: exibir o
 * mais forte faria o certificado afirmar leitura sobre quem só recebeu. Grupo vazio não tem o que
 * afirmar e cai em `PENDING`.
 */
export function statusEntregaMaisFraco(
  destinatarios: Pick<DestinatarioMensagemCertificado, 'statusEntrega'>[],
): MensagemStatus {
  return destinatarios.reduce<MensagemStatus>(
    (maisFraco, destinatario) =>
      FORCA_STATUS[destinatario.statusEntrega] < FORCA_STATUS[maisFraco]
        ? destinatario.statusEntrega
        : maisFraco,
    destinatarios.length > 0 ? 'SEEN' : 'PENDING',
  );
}
